import React from "react";
import { Ship, ShieldCheck } from "lucide-react";
import { LegalLinks } from "@/components/LegalLayout";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row">
      <div className="hidden lg:flex lg:w-1/2 navy-gradient relative overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1756670813432-df0b2cd327c5?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Luxury yacht on open water"
          className="absolute inset-0 w-full h-full object-cover opacity-35"
        />
        <div className="absolute inset-0 navy-gradient opacity-70" />
        <div className="relative z-10 flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 rounded-xl gold-gradient flex items-center justify-center">
              <Ship className="w-6 h-6 text-navy" />
            </div>
            <div>
              <div className="font-serif text-xl font-bold">Marine Ad AI</div>
              <div className="text-xs uppercase tracking-widest text-gold/80">Campaign Studio</div>
            </div>
          </div>
          <div>
            <h1 className="font-serif text-4xl xl:text-5xl font-bold leading-tight mb-4">
              Turn your inventory into <span className="text-gold">ready-to-run</span> marketing.
            </h1>
            <p className="text-slate-300 text-base max-w-md">
              Every boat on your lot, transformed into scroll-stopping ads, captions and campaigns - in seconds.
            </p>
          </div>
          <div className="flex items-center gap-2 text-sm text-slate-300">
            <ShieldCheck className="w-4 h-4 text-gold" />
            Each dealership operates in an isolated, secure workspace.
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6 sm:p-10 bg-background">
        <div className="w-full max-w-md fade-up">
          <div className="lg:hidden flex items-center gap-2.5 mb-8">
            <div className="w-10 h-10 rounded-lg gold-gradient flex items-center justify-center">
              <Ship className="w-5 h-5 text-navy" />
            </div>
            <span className="font-serif text-xl font-bold text-navy">Marine Ad AI</span>
          </div>
          <h2 className="font-serif text-3xl font-bold text-navy mb-1">{title}</h2>
          <p className="text-muted-foreground mb-8">{subtitle}</p>
          {children}
          {footer && <div className="mt-6 text-center text-sm text-muted-foreground">{footer}</div>}
          <LegalLinks testPrefix="auth-footer" className="mt-8 justify-center text-muted-foreground" />
        </div>
      </div>
    </div>
  );
}
